import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
//中台路由
import mpRouter from './mp.js'
import mgRouter from './mg.js'
import Login from '@/views/Login.vue'
import TourismLogin from '@/views/TourismLogin.vue'
import TechLogin from '@/views/TechLogin.vue'
import MpMain from '@/views/mp/Main.vue'
import MgMain from '@/views/mg/Main.vue'
//const MpMain = resolve => require(['@/views/mp/Main.vue'], resolve)
//const MgMain = resolve => require(['@/views/mg/Main.vue'], resolve)
const router = new Router({
	mode: 'history',
	base: __dirname,
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/techLogin',
			name: 'techLogin',
			component: TechLogin
		},
		{
			path: '/tourismLogin',
			name: 'tourismLogin',
			component: TourismLogin
		},
		{
			name: 'mp',
			path: '/mp',
			component: MpMain,
			children:mpRouter
		},
		{
			name: 'mg',
			path: '/mg',
			component: MgMain,
			children:mgRouter
		}
	]
})

//router.beforeEach((to, from, next) => {
//	next()
//})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js